import gql from "graphql-tag";

export const GENERATE_RESUME_TOKEN_LINK = gql`
  mutation GenerateResumeTokenLink($companyCreationId: ID!, $linkType: ResumeLinkType) {
    generateResumeTokenLink(companyCreationId: $companyCreationId, linkType: $linkType)
  }
`;
